export const CCtaColumnsFragment = `
  fragment ctaColumns on ctaColumns_MatrixField {
    ... on ctaColumns_block_Entry {
      buttons {
        ... on buttons_Entry {
          heading
          cta {
            type
            url
            text
            target
          }
        }
      }
    }
  }
`
